import { FormularioService } from 'src/app/services/formulario.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormDto } from '../../model/form-dto';
import { MockForm } from '../../model/mock-form';
import { FormFormuleService } from '../../service/form-formule.service';

@Component({
  selector: 'app-list-form',
  templateUrl: './list-form.component.html',
  styleUrls: ['./list-form.component.scss']
})
export class ListFormComponent implements OnInit {

  listForm: FormDto[] = [];
  isUserDev: boolean = false;

  constructor(
    private router: Router,
    private service: FormFormuleService,
    protected formularioService: FormularioService,
  ) { }

  ngOnInit(): void {
    this.getForms();
    this.getUser();
  }

  viewFormule = (id) => {
    this.router.navigateByUrl('adm/form/formule/' + id);
  }

  getUser = async () => {
    await this.service.getUserCwid()
      .then(res => {
        if (res.length > 0) this.isUserDev = true;
        else {
          this.formularioService.userIsAdmin().subscribe(adm => {
            if (adm) this.isUserDev = true;
            else {
              this.formularioService.userIsManager().subscribe(manager => {
                if (manager) this.isUserDev = true;
                else this.isUserDev = false;
              })
            }
          })
        }
      })
      .catch(err => {
        console.error(err);
      })

  }

  getForms = () => {
    this.service.getList()
      .then(res => {
        this.listForm = res;
        this.listForm.forEach(async element => {
          let count = await this.getFormule(element.id);
          element.countFormule = count;
        });
      })
      .catch(err => {
        console.error(err);
      })
  }

  getFormule = async (idForm) => {
    let formule = await this.service.getFormuleByIdForm(idForm);
    return formule.length;
  }

  new = () => {
    this.router.navigateByUrl('adm/form/new');
  }

  edit = (id) => {
    this.router.navigateByUrl('adm/form/edit/' + id);
  }

}
